import {
    GetReleasedCmsFrameworksQuery,
    type GetQuestionnairesQuery,
} from "@generated/client/graphql";

export type QuestionnairesList = GetQuestionnairesQuery["questionnaires"];

export type ExternalQuestionnairesListItem = QuestionnairesList[number];

export type QuestionnaireCreationModalStep =
    | "templates"
    | "questionnaireForm"
    | "review"
    | "success";

export type QuestionnaireTemplate = NonNullable<
    GetReleasedCmsFrameworksQuery["releasedCmsFrameworks"]
>[number];

export const questionnaireStatus = {
    TODO: "todo",
    IN_PROGRESS: "inProgress",
    VALIDATED: "validated",
} as const;

export type QuestionnaireStatus =
    (typeof questionnaireStatus)[keyof typeof questionnaireStatus];
